export enum TokenModel {
    token_name= 'Token',
    user_info = 'UserInfo',
    store_info = 'StoreInfo'
}